<template>
  <div class="pp-tab-surface">
    <div
      v-if="labels.length"
      class="pp-amen-grid"
    >
      <div
        v-for="(label, idx) in labels"
        :key="`${label}-${idx}`"
        class="pp-amen"
      >
        <div class="ic">
          <Icon
            :name="`lucide:${resolveAmenityLucideIconName(label)}`"
            class="h-5 w-5"
            aria-hidden="true"
          />
        </div>
        <div class="t">{{ label }}</div>
      </div>
    </div>
    <div
      v-else
      class="empty"
    >
      <p>{{ t('property.v2Amenities.empty') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropertyDetailed } from '@/types/properties';
import { amenityLabelsFromApi } from '@/utils/amenityBadges';
import { resolveAmenityLucideIconName } from '@/utils/amenityIconMap';

const props = defineProps<{
  item: PropertyDetailed;
}>();

const { t, locale } = useI18n();

const labels = computed(() => amenityLabelsFromApi(props.item.amenities, locale.value || 'en'));
</script>

<style scoped lang="scss">
.pp-tab-surface {
  background: #f8f7f3;
  border-radius: 20px;
  padding: 28px;
}

.pp-amen-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 744px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.pp-amen {
  background: white;
  border: 1px solid rgba(13, 15, 21, 0.08);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  .ic {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #f8f7f3;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #0d0f15;
  }

  .t {
    font-size: 13px;
    font-weight: 700;
    color: #0d0f15;
  }
}

.empty {
  background: white;
  border: 1px solid rgba(13, 15, 21, 0.08);
  border-radius: 14px;
  padding: 40px;
  text-align: center;
  color: rgba(13, 15, 21, 0.62);
  font-size: 14px;
}
</style>
